import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AnchorLink from 'components/AnchorLink';
import styles from './ConflictMessage.scss';

const ConflictMessage = ({ className = '', pathname = null, resolution, search = null, text }) => {
  const shouldDisplayLink = !!search && !!pathname;
  const classes = classNames(
    styles.conflict,
    styles.textOnly,
    {
      [styles.hasResolution]: !!resolution,
    },
    className,
  );

  return (
    <div className={classes} data-test="conflict-message">
      <div className={styles.content}>
        <div className={styles.message}>{text}</div>
        {resolution &&
          (shouldDisplayLink ? (
            <AnchorLink className={styles.resolution} to={{ pathname, search }}>
              {resolution}
            </AnchorLink>
          ) : (
            <div className={styles.resolution}>{resolution}</div>
          ))}
      </div>
    </div>
  );
};

ConflictMessage.propTypes = {
  className: PropTypes.string,
  pathname: PropTypes.string,
  resolution: PropTypes.node,
  search: PropTypes.string,
  text: PropTypes.string,
};

export default ConflictMessage;
